import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpBackend from 'i18next-http-backend'
// the translations
// (tip move them in a JSON file and import them)

const supportedLanguages = ['jp', 'en'] as const
const storedLang = localStorage.getItem('lang')
const initialLang = supportedLanguages.includes(
  storedLang as (typeof supportedLanguages)[number]
)
  ? storedLang
  : 'jp'

i18n
  .use(HttpBackend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: initialLang,
    fallbackLng: 'jp',
    supportedLngs: supportedLanguages as unknown as string[],
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false,
    },
  })

export default i18n
